<div class="status-bullet status-{{visitStatus()}}">
  <span class="bullet-text">A refill has been requested.
    @if(!isWithinVisit()) {
      <button variant="success" (click)="onNavigate($event)">Review refill request.</button>
    }
  </span>
</div>